<template>
  <div class="flex flex-col">
    <base-button
      :action="actions.assignTour"
      :disabled="!availableForAssign"
      size="sm"
      context="outline"
      class="w-full border-b"
      @click="$emit('changeState', actions.assignTour)"
    />
    <base-button
      :action="actions.unAssignTour"
      :disabled="!availableForUnAssign"
      size="sm"
      context="outline"
      class="w-full border-b"
      @click="$emit('changeState', actions.unAssignTour)"
    />
    <base-button
      :action="actions.exportTour"
      :disabled="!availableForExport"
      size="sm"
      context="outline"
      class="w-full border-b"
      @click="$emit('changeState', actions.exportTour)"
    />
    <base-button
      :action="actions.discardTour"
      :disabled="!availableForDiscard"
      size="sm"
      context="outline"
      class="w-full border-b"
      @click="$emit('changeState', actions.discardTour)"
    />
    <base-button
      :action="actions.simulateReadout"
      :disabled="!availableForSimulation"
      size="sm"
      context="outline"
      class="w-full border-b"
      @click="$emit('changeState', actions.simulateReadout)"
    />
    <base-button
      :action="actions.restoreTour"
      :disabled="!isDiscarded"
      size="sm"
      context="outline"
      class="w-full border-b"
      @click="$emit('restore')"
    />
    <base-button
      :action="actions.deleteTour"
      :disabled="!isDiscarded"
      size="sm"
      context="outline"
      class="w-full border-b text-red-default"
      @click="$emit('delete')"
    />
  </div>
</template>

<script>
import {BaseButton} from '@/components/base'
export default {
  data() {
    return {
      actions: {
        assignTour: 'assign_tour',
        exportTour: 'export_tour',
        discardTour: 'discard_tour',
        simulateReadout: 'simulate_readout',
        unAssignTour: 'unassign_tour',
        deleteTour: 'delete_tour',
        restoreTour: 'restore_tour',
      },
    }
  },
  computed: {
    availableForAssign() {
      return ['Open', 'Completed', 'Assigned'].includes(this.currentState) && !this.isDiscarded
    },
    availableForDiscard() {
      return ['Open', 'Completed'].includes(this.currentState) && !this.isDiscarded
    },
    availableForExport() {
      return ['Completed'].includes(this.currentState)
    },
    availableForSimulation() {
      return ['In Progress'].includes(this.currentState)
    },
    availableForUnAssign() {
      return ['Assigned'].includes(this.currentState)
    },
  },
  props: {
    currentState: {
      type: String,
      required: true,
    },
    isDiscarded: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    BaseButton,
  },
}
</script>
